'use client'
import { useBlogHomePage } from "@/providers/strapi/content/types/singleTypes/blog-home-page";
import { Article, ArticleCard } from "./common";
import { PageProps } from "@/types";
import clsx from "clsx";
import ReactMarkdown from "react-markdown";

export function Spotlight(props: PageProps<{
  articles: Article[];
}>) {
  // const tr = X.useTranslator(props);
  const lastArticleCard = useBlogHomePage('lastArticlesCard')
  return (
    <section className="w-full bg-surface-purple py-8 pb-8 xl:py-12 xl:pb-6 overflow-x-hidden xl:mb-4">
      <div className="xl:max-w-content xl:mx-auto">
        {/* <h2 className="text-[17px] xl:text-[20px] font-semibold mb-4 mx-mobile-margin xl:mx-0">
          {tr({ en: "In the spotlight", fr: "À la une" })}
          {lastArticleCard.title}
        </h2> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
          h1: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
          h2: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
          h3: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
          h4: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
          h5: ({ ...props }) => <h2 {...props} className="text-[17px] xl:text-[20px] font-semibold [&strong]:font-bold mb-4 mx-mobile-margin xl:mx-0" />,
        }}>
          {lastArticleCard.title}
        </ReactMarkdown>
        <div
          className="flex flex-row gap-6 overflow-x-auto scroll-snap-x snap-mandatory xl:grid xl:grid-cols-3 xl:overflow-x-visible xl:snap-none"
          style={{
            scrollbarWidth: "none", // Firefox
            WebkitOverflowScrolling: "touch",
          }}
        >
          {props.articles.slice(0, 3).map((article, index) => (
            <ArticleCard
              key={index}
              article={article}
              locale={props.locale}
              className={clsx("flex-shrink-0 snap-start w-88 xl:w-auto first:pl-mobile-margin last:pr-mobile-margin xl:first:pl-0 xl:last:pr-0")}
              large
            />
          ))}
        </div>
      </div>
    </section>
  );
}
